"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChartPyramid: function() {
        return ChartPyramid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ChartPyramid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.36554 3.31075C10.4978 1.20236 13.5218 1.20345 14.6526 3.31265L17.4393 8.51088C17.4458 8.52234 17.452 8.53394 17.458 8.54567L20.6559 14.5109C20.6623 14.5223 20.6686 14.5339 20.6745 14.5457L22.3026 17.5825C23.374 19.5811 21.9262 22 19.6586 22H4.34524C2.07668 22 0.628946 19.5792 1.70224 17.5806L3.33244 14.545C3.33844 14.5333 3.34467 14.5217 3.35112 14.5103L6.55459 8.54504C6.5606 8.53331 6.56682 8.52171 6.57327 8.51025L9.36554 3.31075ZM8.04339 10L5.89529 14H18.1127L15.9683 10H8.04339ZM14.8962 8H9.11744L11.1275 4.25698C11.505 3.55419 12.513 3.55455 12.8899 4.25762L14.8962 8ZM19.1849 16H4.82124L3.46424 18.5269C3.10647 19.1931 3.58905 20 4.34524 20H19.6586C20.4145 20 20.8971 19.1937 20.5399 18.5275L19.1849 16Z",
        fill: "currentColor"
    })
}), "ChartPyramid");
const _default = ChartPyramid;
